// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// ** API Imports
import axios from '@src/service/axios';
import { toast } from 'react-toastify';

export const getAttendance = createAsyncThunk('dashboardSliceData/getAttendance', async (data) => {
    const query = queryString.stringify(data);
    try {
        let response = await axios.get('/Attendance/admin-side-attendance?' + query, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(JSON.parse(response?.data));
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getEmpAttendance = createAsyncThunk('dashboardSliceData/getEmpAttendance', async (data) => {
    try {
        const query = queryString.stringify(data);
        let response = await axios.get('/Attendance/employee-side-attendance?' + query, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(JSON.parse(response?.data));
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getTeamOnLeave = createAsyncThunk('dashboardSliceData/getTeamOnLeave', async (data) => {
    const query = queryString.stringify(data);
    try {
        let response = await axios.get('/leaverequest/leave-month-wise?' + query, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (error) {
        console.log('err', error);
        // toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(error);
    }
});

export const getWhoIsIn = createAsyncThunk('dashboardSliceData/getWhoIsIn', async (data) => {
    try {
        let response = await axios.get('/Attendance/who-is-in?date=' + data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        console.log('err', err);
        // toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getReview = createAsyncThunk('dashboardSliceData/getReview', async () => {
    try {
        let response = await axios.get('/dashboard/review', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const getDashBoardInPunch = createAsyncThunk('dashboardSliceData/getDashBoardInPunch', async () => {
    try {
        let response = await axios.get('/dashboard/in-punch', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const getDashBoardSalary = createAsyncThunk('dashboardSliceData/getDashBoardSalary', async () => {
    try {
        let response = await axios.get('/dashboard/salary-details', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const getUpComingHoliday = createAsyncThunk('dashboardSliceData/getUpComingHoliday', async () => {
    try {
        let response = await axios.get('/Dashboard/holiday', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        // toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const getDashBoardSalarySlip = createAsyncThunk('dashboardSliceData/getDashBoardSalarySlip', async () => {
    try {
        let response = await axios.get('/dashboard/salary-slip-download', {
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const dashboardSlice = createSlice({
    name: 'dashboardSliceData',
    initialState: {
        review: [],
        dashboardSalary: [],
        dashBoardInPunch: {}
    },
    extraReducers: (builder) => {
        builder.addCase(getReview.fulfilled, (state, action) => {
            state.review = action?.payload;
            return;
        });
        builder.addCase(getWhoIsIn.fulfilled, (state, action) => {
            state.employeeWhoIsIn = action?.payload;
            return;
        });
        builder.addCase(getAttendance.fulfilled, (state, action) => {
            state.attendance = action?.payload;
            return;
        });
        builder.addCase(getTeamOnLeave.fulfilled, (state, action) => {
            state.teamOnLeave = action?.payload;
            return;
        });
        builder.addCase(getEmpAttendance.fulfilled, (state, action) => {
            state.attendance = action?.payload;
            return;
        });
        builder.addCase(getUpComingHoliday.fulfilled, (state, action) => {
            state.upComingHoliday = action?.payload;
            return;
        });
        builder.addCase(getDashBoardSalary.fulfilled, (state, action) => {
            state.dashboardSalary = action?.payload;
            return;
        });
        builder.addCase(getDashBoardInPunch.fulfilled, (state, action) => {
            state.dashBoardInPunch = action?.payload;
            return;
        });
    }
});

export default dashboardSlice.reducer;
